/* masaustu: taksit fiyatin altinda, uyelik daveti ayri satirda */
(function(){try{var st=document.createElement('style');st.textContent='@media (min-width:990px){#content .price-container .mel-tk-pdp{flex:0 0 100%;width:100%;text-align:left;margin:6px 0 0;font-size:14px}#content .mel-puan .mel-puan-sep{display:none}#content .mel-puan .mel-puan-uye{display:block;margin-top:2px}}';document.head.appendChild(st);}catch(e){}})();
/* NEW41 — mel-ekstra.js (TASLAK)
   1) Benim numaram: numara hafızası, koleksiyonda "sadece numaramda stokta olanlar", ürün sayfasında ön seçim
   2) Rivo puan satırı: ürün sayfası + sepet çekmecesi
   3) Kalıp kutusu / kaydırıcı metinleri (müşteri geri bildirimi dili) */
(function(){
  'use strict';
  var EK = window.MEL_EK || {};
  var URUN = window.MEL_URUN || null;
  var DIL = (document.documentElement.lang || 'tr').slice(0, 2).toLowerCase();
  if (DIL !== 'tr') return;
  var KOK = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/').replace(/\/$/, '');

  function el(tag, cls, html){ var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function sayi(t){ var s = String(t || '').replace(/[^\d,]/g, '').replace(',', '.'); var n = parseFloat(s); return isNaN(n) ? 0 : n; }
  function fmt(n){ return Math.round(n).toLocaleString('tr-TR'); }
  function oku(k){ try { return localStorage.getItem(k) || ''; } catch(e){ return ''; } }
  function yaz(k, v){ try { localStorage.setItem(k, v); } catch(e){} }

  /* ================= 1) BENİM NUMARAM ================= */
  var ANAHTAR = { y: 'mel_numara', m: 'mel_numara_mini' };
  var YETISKIN = ['35/36', '36', '37', '38', '39', '40', '41/42'];
  var MINI = ['22/23', '24', '25/26', '27', '28/29', '30', '31', '32', '33', '34'];

  function normNo(v){ return String(v || '').trim().replace('.', '/').toUpperCase(); }
  function numaraMi(v){ return /^\d{2}(\/\d{2})?$/.test(normNo(v)); }
  function tur(v){ var n = parseInt(normNo(v), 10); return n >= 35 ? 'y' : 'm'; }
  function kayit(t){ return normNo(oku(ANAHTAR[t])); }
  function kaydet(v, kaynak){
    v = normNo(v); if (!numaraMi(v)) return;
    var t = tur(v);
    if (kaynak === 'gecmis' && kayit(t)) return; // elle seçilen öncelikli
    yaz(ANAHTAR[t], v);
  }

  // Girişli müşterinin geçmiş siparişlerinden en sık numara
  (function gecmistenOgren(){
    var g = (EK.gecmis || []).filter(Boolean); if (!g.length) return;
    var say = { y: {}, m: {} };
    g.forEach(function(r){
      String(r[1] || '').split(' / ').forEach(function(p){
        if (!numaraMi(p)) return; var v = normNo(p), t = tur(v);
        if (/^MINI /i.test(r[0] || '') && t === 'y') return;
        say[t][v] = (say[t][v] || 0) + 1;
      });
    });
    ['y', 'm'].forEach(function(t){
      var en = Object.keys(say[t]).sort(function(a, b){ return say[t][b] - say[t][a]; })[0];
      if (en) kaydet(en, 'gecmis');
    });
  })();

  function filtreDegerleri(v){ v = normNo(v); return v.indexOf('/') > -1 ? [v, v.replace('/', '.')] : [v]; }

  // --- Ürün sayfası: seçimi öğren + kayıtlı numarayı ön seç ---
  function bedenInputlari(){
    var f = document.querySelector('#content .product-form') || document.querySelector('.product-form');
    if (!f) return [];
    var gruplar = {};
    f.querySelectorAll('input.js-option[type="radio"]').forEach(function(i){ (gruplar[i.name] = gruplar[i.name] || []).push(i); });
    for (var n in gruplar){ if (gruplar[n].some(function(i){ return numaraMi(i.value); })) return gruplar[n]; }
    return [];
  }
  var onSecildi = false;
  function pdpNumara(){
    var ins = bedenInputlari(); if (!ins.length) return;
    if (!ins[0].dataset.melDinle){
      ins.forEach(function(i){
        i.dataset.melDinle = '1';
        i.addEventListener('change', function(e){ if (e.isTrusted && i.checked) kaydet(i.value, 'pdp'); });
      });
      var f = document.querySelector('#content form.js-product-form') || ins[0].form;
      if (f) f.addEventListener('submit', function(){ var c = ins.filter(function(i){ return i.checked; })[0]; if (c) kaydet(c.value, 'pdp'); });
    }
    if (onSecildi) return; onSecildi = true;
    if (/[?&]variant=/.test(location.search)) return;
    var t = URUN && /^MINI /i.test(URUN.baslik || '') ? 'm' : 'y';
    var v = kayit(t); if (!v) return;
    var hedef = ins.filter(function(i){ return normNo(i.value) === v; })[0];
    if (!hedef || hedef.checked || hedef.classList.contains('is-unavailable') || hedef.disabled) return;
    var onceki = ins.filter(function(i){ return i.checked; })[0];
    var bekle = window.customElements && customElements.whenDefined ? customElements.whenDefined('variant-picker') : Promise.resolve();
    bekle.then(function(){ setTimeout(function(){
      var idEl = document.querySelector('#content form.js-product-form [name="id"]');
      var ilk = idEl ? idEl.value : '';
      hedef.click();
      setTimeout(function(){
        // Güvenlik: varyant kimliği değişmediyse seçimi geri al (sepete yanlış numara gitmesin)
        if (idEl && idEl.value === ilk){
          hedef.dispatchEvent(new Event('change', { bubbles: true }));
          setTimeout(function(){ if (idEl.value === ilk && onceki){ onceki.click(); } }, 400);
        }
      }, 500);
    }, 600); });
  }

  // --- Koleksiyon: numara çubuğu ---
  function koleksiyonTuru(){
    var h = (EK.koleksiyon || location.pathname).toLowerCase();
    if (/mini/.test(h)) return 'm';
    var ps = new URLSearchParams(location.search).getAll('filter.v.option.size');
    if (ps.length && tur(ps[0]) === 'm') return 'm';
    return 'y';
  }
  function filtreliUrl(v, ac){
    var u = new URL(location.href), p = u.searchParams;
    p.delete('filter.v.option.size'); p.delete('filter.v.availability'); p.delete('page');
    if (ac){ filtreDegerleri(v).forEach(function(x){ p.append('filter.v.option.size', x); }); p.set('filter.v.availability', '1'); }
    return u.pathname + (p.toString() ? '?' + p.toString() : '');
  }
  function aktifMi(v){
    var p = new URLSearchParams(location.search);
    var s = p.getAll('filter.v.option.size').map(normNo);
    return p.get('filter.v.availability') === '1' && s.length > 0 && s.every(function(x){ return x === v; });
  }
  function koleksiyonCubugu(){
    if (EK.sablon !== 'collection') return;
    var grid = document.querySelector('.collection-listing > .product-grid') || document.querySelector('#content .collection-listing .product-grid'); if (!grid) return;
    var kap = grid.parentNode; if (kap.querySelector('.mel-nb')) return;
    var t = koleksiyonTuru(), v = kayit(t), liste = t === 'm' ? MINI : YETISKIN;
    var bar = el('div', 'mel-nb');
    function chipler(secili){
      var c = el('div', 'mel-nb__chips');
      liste.forEach(function(x){
        var b = el('button', 'mel-nb__chip' + (x === secili ? ' is-on' : ''), x); b.type = 'button';
        b.addEventListener('click', function(){ yaz(ANAHTAR[t], x); location.href = filtreliUrl(x, true); });
        c.appendChild(b);
      });
      return c;
    }
    if (v){
      var ac = aktifMi(v);
      var sw = el('a', 'mel-nb__sw' + (ac ? ' is-on' : ''), '<span class="mel-nb__tr"></span><span>Sadece <b>' + v + '</b> numaramda stokta olanlar</span>');
      sw.href = filtreliUrl(v, !ac); sw.setAttribute('role', 'switch'); sw.setAttribute('aria-checked', ac ? 'true' : 'false');
      var deg = el('span', 'mel-nb__deg', 'Numaram: ' + v + ' · ');
      var db = el('button', '', 'Değiştir'); db.type = 'button';
      db.addEventListener('click', function(){ if (!bar.querySelector('.mel-nb__chips')) bar.appendChild(chipler(v)); });
      deg.appendChild(db);
      bar.appendChild(sw); bar.appendChild(deg);
    } else {
      bar.appendChild(el('span', '', '<b>Numaranı seç</b>, sadece stokta olanları göstereyim:'));
      bar.appendChild(chipler(''));
    }
    kap.insertBefore(bar, grid);
  }

  /* ================= 2) RIVO PUAN ================= */
  function puanKurali(){
    var oran = 0.1, uyelik = 200;
    try {
      var w = (window.Rivo && Rivo.loy_config && Rivo.loy_config.ways_to_earn) || [];
      w.forEach(function(x){
        if (x.trigger === 'order_placed' && x.status === 'active' && x.points_amount) oran = x.points_amount / (x.currency_base_amount || 1);
        if (/kayıt|üye|sign/i.test(x.title || '') && x.points_amount) uyelik = x.points_amount;
      });
    } catch(e){}
    return { oran: oran, uyelik: uyelik };
  }
  function bakiye(){
    try { var a = window.Rivo && Rivo.account_profile; var p = a && (a.points_tally != null ? a.points_tally : a.points_balance); return (p != null && !isNaN(p)) ? +p : null; } catch(e){ return null; }
  }
  function seciliFiyat(){
    if (!URUN || !URUN.varyantlar) return 0;
    var f = document.querySelector('#content form.js-product-form [name="id"]') || document.querySelector('form.js-product-form [name="id"]');
    var id = f ? parseInt(f.value, 10) : 0;
    for (var i = 0; i < URUN.varyantlar.length; i++) if (URUN.varyantlar[i].id === id) return URUN.varyantlar[i].fiyat / 100;
    return URUN.varyantlar[0].fiyat / 100;
  }
  function pdpPuan(){
    var fiyatEl = document.querySelector('#content .product-info__price'); if (!fiyatEl || !URUN) return;
    var k = puanKurali(), tutar = seciliFiyat(); if (!tutar) return;
    var p = Math.floor(tutar * k.oran);
    var html = EK.uye
      ? '⭐ Bu üründen <b>' + fmt(p) + ' puan</b> kazanacaksın' + (bakiye() != null ? ' · Mevcut puanın: ' + fmt(bakiye()) : '')
      : '⭐ Bu üründen <b>' + fmt(p) + ' puan</b> kazan (' + fmt(p) + ' TL değerinde)<span class="mel-puan-sep"> · </span><span class="mel-puan-uye"><a href="' + KOK + '/account/register">Ücretsiz üye ol</a>, +' + fmt(k.uyelik) + ' hoş geldin puanı</span>';
    var e = document.querySelector('#content .mel-puan');
    if (!e){
      e = el('div', 'mel-puan');
      var tk = fiyatEl.parentNode.querySelector('.mel-tk-pdp');
      var sonra = tk || fiyatEl; sonra.parentNode.insertBefore(e, sonra.nextSibling);
    } else {
      var tk2 = fiyatEl.parentNode.querySelector('.mel-tk-pdp');
      if (tk2 && e.previousElementSibling !== tk2) tk2.parentNode.insertBefore(e, tk2.nextSibling);
    }
    if (e.innerHTML !== html) e.innerHTML = html;
  }
  function sepetPuan(){
    var d = document.querySelector('cart-drawer'); if (!d) return;
    var alt = d.querySelector('.subtotal'); if (!alt) return;
    var toplam = sayi((alt.querySelector('.theme-money') || alt).textContent);
    var mevcut = d.querySelector('.mel-puan-sepet');
    if (!toplam){ if (mevcut) mevcut.remove(); return; }
    var p = Math.floor(toplam * puanKurali().oran);
    var html = EK.uye
      ? '<span>⭐ Bu siparişle kazanacağın</span><span><b>' + fmt(p) + ' puan</b></span>'
      : '<span>⭐ Üye olursan bu siparişle</span><span><b>' + fmt(p) + ' puan</b> kazanırsın</span>';
    if (!mevcut){
      mevcut = el('div', 'mel-puan-sepet');
      var tk = d.querySelector('.mel-tk-sepet'); var sonra = tk || alt;
      sonra.parentNode.insertBefore(mevcut, sonra.nextSibling);
    }
    if (mevcut.innerHTML !== html) mevcut.innerHTML = html;
  }

  /* ================= 3) KALIP METİNLERİ ================= */
  var KALIP = {
    kucuk:       ['Küçük Kalıp', 'Müşterilerimizin çoğu bu modelde bir numara büyüğünü tercih ediyor.'],
    hafif_kucuk: ['Kalıbı Hafif Küçük', 'İki numara arasındaysan bir numara büyüğünü tercih et.'],
    hafif_buyuk: ['Kalıbı Hafif Büyük', 'İki numara arasındaysan bir numara küçüğünü tercih et.'],
    buyuk:       ['Büyük Kalıp', 'Müşterilerimizin çoğu bu modelde bir numara küçüğünü tercih ediyor.']
  };
  function kalipMetin(){
    var ust = document.querySelector('.pdpk-ust');
    if (ust && ust.dataset.mel !== '1'){ ust.textContent = 'Müşteri geri bildirimlerine göre bu modelin kalıbı:'; ust.dataset.mel = '1'; }
    var k = KALIP[EK.kalip]; var kutu = document.querySelector('.pdpk-kutu');
    if (k && kutu && kutu.dataset.mel !== '1'){
      var b = kutu.querySelector('.pdpk-b'), m = kutu.querySelector('.pdpk-m');
      if (b) b.textContent = k[0]; if (m) m.textContent = k[1];
      kutu.dataset.mel = '1';
    }
  }

  /* ================= Çalıştırma ================= */
  function pdp(){ if (!URUN) return; try { pdpNumara(); } catch(e){} try { pdpPuan(); } catch(e){} try { kalipMetin(); } catch(e){} }
  function hepsi(){ pdp(); try { sepetPuan(); } catch(e){} try { koleksiyonCubugu(); } catch(e){} }
  var z; function tetik(){ clearTimeout(z); z = setTimeout(hepsi, 120); }
  function baslat(){
    hepsi(); setTimeout(hepsi, 800); setTimeout(hepsi, 2000);
    document.addEventListener('change', tetik, true);
    document.addEventListener('on:variant:change', tetik);
    document.addEventListener('on:cart:change', tetik);
    var d = document.querySelector('cart-drawer');
    if (d && window.MutationObserver) new MutationObserver(tetik).observe(d, { childList: true, subtree: true });
    var fk = document.querySelector('#content .filter-container');
    if (fk && window.MutationObserver) new MutationObserver(function(){ if (!document.querySelector('.mel-nb')) tetik(); }).observe(fk, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat); else baslat();
})();
